import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

interface JobUsageData {
  current_usage: number;
  limit: number | 'Unlimited';
  percentage_used: number;
  is_at_limit: boolean;
}

interface JobUsageResponse {
  job_id: number;
  subscription_tier: string;
  usage: {
    photos_per_job: JobUsageData;
    files_per_job: JobUsageData;
  };
}

export const useJobUsage = (jobId: string | number | undefined) => {
  const { data, isLoading, error, refetch } = useQuery<JobUsageResponse>({
    queryKey: ['job-usage', jobId],
    queryFn: async () => {
      const response = await api.get<JobUsageResponse>(`/api/usage/job/${jobId}/`);
      return response.data;
    },
    enabled: !!jobId,
    refetchInterval: 60000, // Refresh every minute
    staleTime: 30000, // Consider data stale after 30 seconds
  });

  return {
    photoUsage: data?.usage?.photos_per_job,
    docUsage: data?.usage?.files_per_job,
    isLoading,
    error,
    refetch,
    subscriptionTier: data?.subscription_tier,
  };
};